import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

/**
 * @desc  Hobby tab content in candidate profile section
 * @param props
 * @return DOMElement
 */

const Hobby = props => {
  return (
    <Col xs={12} md={4} className="candidate-hobbies-interest">
      {props.hobby}
    </Col>
  );
};

export default Hobby;



// WEBPACK FOOTER //
// ./src/components/Client/Hobby/Hobby.js